import React, { useState } from 'react';
import { Modal, Button, Spinner, Col, Row, InputGroup } from 'react-bootstrap';
import { sendMailProjectDocument } from '@lib/api';
import { ConfirmSolid, ExclamationRed, IcoDownloadCloudArrow } from '@icons';
import { OETrans } from 'components/translation/OETrans';

const ModalDownloadReportTimesheets = ({
	projectId,
	// modelFilterString,
	filterQueryParamsString,
	// isFiltered,
	showModalDownloadReportTimesheets,
	setShowModalDownloadReportTimesheets,
	hasMissingReport = false,
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [result, setResult] = useState('');
	const [reportType, setReportType] = useState('');
	const [successMessageReport, setSuccessMessageReport] = useState('');

	const handleDownloadReport = async () => {
		setIsLoading(true);

		let filterString = filterQueryParamsString || '';

		let sendResult = await sendMailProjectDocument(projectId, 'resume' + reportType, filterString);

		if (sendResult.success) {
			setIsLoading(false);
			setResult('success');
			setSuccessMessageReport('Il report è in elaborazione e al completamento ti verrà inviata una notifica.');
		} else {
			setIsLoading(false);
			setResult('error');
		}
	};

	const onHide = () => {
		setShowModalDownloadReportTimesheets(false);
		setTimeout(() => {
			setResult('');
			setReportType('');
		}, 500);
	};

	return (
		<Modal size={isLoading || result ? '' : 'lg'} show={showModalDownloadReportTimesheets} onHide={onHide} centered>
			{isLoading ? (
				<>
					<Modal.Body className="text-center">
						<Row className="aligns-items-center justify-content-center p-5">
							<Spinner animation="border" className="new-spinner-big" />
							<span className="mt-5" style={{ fontSize: '24px', fontWeight: '700' }}>
								Invio del report in corso...
							</span>
						</Row>
					</Modal.Body>
				</>
			) : (
				<>
					{result ? (
						result === 'success' ? (
							<>
								<Modal.Body>
									<div className="text-center mb-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
										<ConfirmSolid className="mt-3 d-block" style={{ width: '40px' }} />
										<span className="mt-4 d-block f-700" style={{ fontSize: '24px' }}>
											Perfetto!
										</span>
										<span className="mt-3 d-block f-400">{successMessageReport}</span>
									</div>
								</Modal.Body>
								<Modal.Footer className="justify-content-center">
									<Button className="new custom-primary-button w-100" style={{ fontWeight: '500' }} onClick={onHide}>
										<OETrans code="common.close" fallback={'Chiudi'} />
									</Button>
								</Modal.Footer>
							</>
						) : (
							<>
								<Modal.Body className="text-center">
									<div className="text-center mb-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
										<ExclamationRed className="mt-3 d-block" />
										<span className="mt-4 d-block f-700" style={{ fontSize: '24px' }}>
											Errore imprevisto
										</span>
										<span className="mt-4 d-block f-400">Si è verificato un errore durante la generazione del report.</span>
										<span className="mt-4 d-block f-400">
											Ti preghiamo di riprovare più tardi o contattare l'amministratore di sistema se il problema persiste.
										</span>
									</div>
								</Modal.Body>
								<Modal.Footer className="justify-content-center">
									<Button className="new custom-primary-button w-100" style={{ fontWeight: '500' }} onClick={onHide}>
										<OETrans code="common.close" fallback={'Chiudi'} />
									</Button>
								</Modal.Footer>
							</>
						)
					) : (
						<>
							<Modal.Body>
								<div className="text-center mb-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
									<IcoDownloadCloudArrow className="mt-2 d-block" style={{ width: '40px' }} />
									<span className="mt-4 d-block f-700" style={{ fontSize: '24px' }}>
										Seleziona un report
									</span>
									<span className="mt-4 d-block f-400">Verrà elaborato il file e al completamento ti verrà inviata una notifica.</span>
									<span className="mt-2 d-block f-700">Di quale versione hai bisogno?</span>
								</div>

								<div>
									<InputGroup className={`download-report-radio-group${reportType === 'timesheets' ? '-checked' : ''}`}>
										<InputGroup.Radio
											className="col-1"
											id="timesheets"
											name="reportType"
											value="timesheets"
											checked={reportType === 'timesheets'}
											onChange={(e) => setReportType(e.target.id)}
										/>
										<InputGroup.Text className="col-11 flex-column align-items-start text-start p-3" style={{ whiteSpace: 'normal' }}>
											<Row>
												<span className="f-700">Report sintetico</span>
											</Row>
											<Row>
												<span className="f-400">
													Il report sintetico fornisce una visione compatta e immediata del flusso documentale, includendo i dati essenziali
													e gli esiti dei controlli effettuati. Ideale per una consultazione rapida o reportistica generale.
												</span>
											</Row>
										</InputGroup.Text>
									</InputGroup>

									<InputGroup className={`download-report-radio-group${reportType === 'analytictimesheets' ? '-checked' : ''} mt-3`}>
										<InputGroup.Radio
											className="col-1"
											id="analytictimesheets"
											name="reportType"
											value="analytictimesheets"
											checked={reportType === 'analytictimesheets'}
											onChange={(e) => setReportType(e.target.id)}
										/>
										<InputGroup.Text className="col-11 flex-column align-items-start text-start p-3" style={{ whiteSpace: 'normal' }}>
											<Row>
												<span className="f-700">Report analitico</span>
											</Row>
											<Row>
												<span className="f-400">
													Il report analitico offre una rappresentazione dettagliata del flusso documentale, riportando in modo puntuale
													tutte le informazioni associate a ciascun documento. Pensata per analisi approfondite o audit.
												</span>
											</Row>
										</InputGroup.Text>
									</InputGroup>

									{hasMissingReport ? (
										<InputGroup className={`download-report-radio-group${reportType === 'missingdocuments' ? '-checked' : ''} mt-3`}>
											<InputGroup.Radio
												className="col-1"
												id="missingdocuments"
												name="reportType"
												value="missingdocuments"
												checked={reportType === 'missingdocuments'}
												onChange={(e) => setReportType(e.target.id)}
											/>
											<InputGroup.Text className="col-11 flex-column align-items-start text-start p-3" style={{ whiteSpace: 'normal' }}>
												<Row>
													<span className="f-700">Report documentale</span>
												</Row>
												<Row>
													<span className="f-400">
														Il report documentale evidenzia in modo puntuale la documentazione non caricata o non disponibile all'interno
														della piattaforma, consentendo un rapido controllo della documentazione da integrare. Ideale per verificare la
														completezza del fascicolo e supportare le attività di compliance.
													</span>
												</Row>
											</InputGroup.Text>
										</InputGroup>
									) : null}
								</div>
							</Modal.Body>

							<Modal.Footer>
								<Row>
									<Col className="col-6">
										<Button className="new custom-outline-button" style={{ fontWeight: '500' }} onClick={onHide}>
											<OETrans code="common.cancel" fallback={'Annulla'} />
										</Button>
									</Col>
									<Col className="col-6">
										<Button
											variant="primary"
											className="new custom-primary-button"
											style={{ fontWeight: '500' }}
											onClick={(e) => handleDownloadReport(e)}
											disabled={isLoading || !reportType}
										>
											Invia
										</Button>
									</Col>
								</Row>
							</Modal.Footer>
						</>
					)}
				</>
			)}
		</Modal>
	);
};
export default ModalDownloadReportTimesheets;
